function _templateObject() {
  var data = _taggedTemplateLiteral(["<dom-module id=\"lumo-date-picker\" theme-for=\"vaadin-date-picker\">\n  <template>\n    <style include=\"lumo-field-button\">\n      :host {\n        outline: none;\n      }\n\n      [part=\"toggle-button\"]::before {\n        content: var(--lumo-icons-calendar);\n      }\n\n      [part=\"clear-button\"]::before {\n        content: var(--lumo-icons-cross);\n      }\n    </style>\n  </template>\n</dom-module>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import '@vaadin/vaadin-lumo-styles/font-icons.js';
import '@vaadin/vaadin-lumo-styles/mixins/field-button.js';
import '@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
var $_documentContainer = html(_templateObject());
document.head.appendChild($_documentContainer.content);